"use client";

import Breadcrumbs from "./breadcrumbs";
import SocialShare from "~/components/metadata";

import wp from "./wp.module.css";
import { Button } from "@heroui/button";

export default function Error() {
    return (
        <div style={{ minHeight:"100vh" }}>
            <>
                <title>{"Ascendi 404 - Ikke funnet"}</title>
                <meta name="description" content={"Fant ikke side"}/>
                <SocialShare
                    title={"Ascendi Bo- og Omsorgstjenester"}
                    description={"Ascendi."}
                    image={"https://www.ascendi.no/preview.jpg"}
                />
            </>
            <header className={wp.header + " " + wp.errorHeader}>
                <div className={wp.headerContent}>
                    <Breadcrumbs category={"Feil"}/>
                    <h1 className={wp.title}>404</h1>
                    <div style={{ paddingTop:'.75rem' }}/>
                </div>
            </header>
            <article className={wp.content}>
                Beklager, vi fant ingen artikkel med dette navnet!
                <Button href="/blog/">
                    Tilbake til bloggen
                </Button>
            </article>
        </div>
    )
}